<template>
  <div>
    <main>
      <div id="HomeContainer" style="background-color:#000; background-image:url(static/images/services-bg.jpg); background-size:100%;">
          <div class="ContentAligher relative" style="z-index:1;">

            <div class="row">
              <div class="col-md-5 col-md-offset-7">
                  <div id="HeroTitle">
                    <h1 class="bold"><span class="small">There’s No </span>
                    <span class="mid">Second Time </span>
                    <span class="mid"> For First Impressions</span></h1>


                    <p>Quality, craftsmanship and customer care are paramount for excellence in modernizations, cab building, architectural drawings and upgrades.</p>

                    <a v-on:click="scrollMeTo('ReadMore');">Read More</a>
                  </div>


              </div>
            </div>
            
          </div>


          <div  ref="ReadMore"></div>
          <div id="ServicesWrap">

<section v-for="(service, key, index) in services_c" class="ContentAligher">
    <template v-if="service.service_type === 'Layout Left'">
        <div :id="slug(service.service_name)" class="sec">
          <div class="row">
            <div class="col-md-6 v_middle">
              <img :src="base_path + service.service_image" class="responsive" />
            </div><!--
            --><div class="col-md-6 v_middle"><h1 class="bold white rightH">{{ service.service_name }}</h1></div>
          </div>

          <div v-html="service.service_content" class="white"> </div>

          <div class="BGArrowRight parallax"  data-speed="-10" data-margin="-500" data-rotate="0" data-rotatestatus="false" ></div>
      </div>
    </template>

    <template v-if="service.service_type === 'Layout Right'">
        <div :id="slug(service.service_name)" class="sec">
                <div class="row">
                  <div class="col-md-6 v_middle T_alignRight hidden-xs hidden-sm"><h1 class="bold white leftH">{{ service.service_name }}</h1></div><!-- 
                --><div class="col-md-6 v_middle">
                    <img :src="base_path + service.service_image" class="responsive" />
                  </div><!--
                --><div class="col-md-6 hidden-lg hidden-md"><h1 class="bold white leftH">{{ service.service_name }}</h1></div>
                </div>

                <div v-html="service.service_content" class="white"> </div>
      </div>
    </template>

    <template v-if="service.service_type === 'Layout Right Text Bottom'">
        <div :id="slug(service.service_name)" class="sec">
          <div class="row">
            <div class="col-md-6 v_middle">
              <img :src="base_path + service.service_image" class="responsive" @load="loaded"/><div class="hidden-xs"><br/><br/><br/><br/></div>
            </div><!--
            --><div class="col-md-6 v_middle">
              <h1 class="bold white rightH">{{ service.service_name }}</h1>
              <div v-html="service.service_content" class="white"> </div>
              <br/><br/>
              </div>
          </div>

          <div class="BGArrowLeft parallax"  data-speed="20" data-margin="200" data-rotate="0" data-rotatestatus="false" ></div>
      </div>
    </template>
</section>



          </div>

      </div>
    </main>
   <!-- <rwv-our-clients></rwv-our-clients>-->
   <section id="OurClientsWrap">
    <div class="bg_yellow">
        <div class="ContentAligher SectionTopSpacing SectionBottomSpacing">
            <div class="row">
              <div class="col-xs-10 col-xs-offset-1 ">
                  <div class="row">
                    <div class="col-md-6 pull-right-md">
                        <h1 class="white bold">{{ title }}</h1>
                        <p>{{ description }}</p><br/>
                    </div>
                    <div class="col-md-6">
                      <div id="testimonialsWrap">
                        <img :src="require('@/assets/images/open-q.png')" id="quoteIcon">
                          <div class="row ">
                            <div class="col-md-11 innerBg">
                                <ul id="testimonialsSlider">
                                  <li v-for="testi in testimonials" @load="loaded"><p>{{ testi.testimonial }}</p><span>{{ testi.name }}</span><span>{{ testi.position_title }}</span></li>
                                </ul>
                              </div>
                            </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
  </section>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';

import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);

import '@/assets/js/lightslider'

import RwvHeader from '@/components/Header'
import RwvFooter from '@/components/Footer'
import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';

export default{
  name: 'Serices',
  components: {
    RwvGeneralForm, 
    RwvOurClients,
    RwvHeader,
    RwvFooter
  },
  data: function() {
    return {
     services_c: [],
     base_path: BASE_URL,
     title: 'Our Clients',
     description:'At USC Elevator Interiors we strive to ensure customer satisfaction and that starts by building relationships with some of the best elevator companies in the business. Our clients know that if they want precision, professionalism, and work that surpasses expectations, we are the ones for the job! ',
     testimonials:[],
    }
  },
  mounted() {

    axios.get(API_BASE_URL + 'services/list/')
    .then(response => {this.services_c = response.data});

    axios.get(API_BASE_URL + 'testimonials/list/')
    .then(response => {this.testimonials = response.data}).finally(function(){
         $('#testimonialsSlider').lightSlider({
            item:1,
            slideMove:1,
            enableTouch:true,
            enableDrag:false,
            loop:false,
            slideMargin:0
          }); 

      });

    //console.log(this.services_c);

      $("#xxx").click(function(){
        $('.resp-tab-item').eq( 1 ).trigger("click");
      });

      $('#processTab').easyResponsiveTabs({ tabidentify: 'vert', type: 'vertical' });


  },
  updated(){
     //$('#processTab').easyResponsiveTabs({ tabidentify: 'vert', type: 'vertical' });
     $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
    }, 100);

  },
  computed: {
    
  },
  methods: {
    sanitizeTitle: function(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
    loaded:function (e) {
        $(this).trigger('resize');
    },
    slug(title){
      return this.sanitizeTitle(title)
    },
    scrollMeTo(refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;
        window.scrollTo(0, top);
    },

  }
}

</script>
<style>
@import './../assets/css/easyResponsiveTabs.css';
@import './../assets/css/lightslider.css';
</style>


// WEBPACK FOOTER //
// src/views/Services.vue